import React from 'react';

const defaultContextValue = {
  channel: 'desktop',
  hosts: {},
  path: '/',
  store: {},
  cookie: {},
  configService: {},
  segment: '',
  isDebugMode: false,
  isAkamaiBot: true,
  customer: {},
  mounted: false
};

const DataProviderContext = React.createContext(defaultContextValue);

export default DataProviderContext;
